/** @format */

import { FormWrap } from "../../../layouts/FormWrap";
import { TextField, Button, ErrorMessage } from "../../../ui-parts/ocnk";
import { Box } from "../../../layouts/Box";
import { ChangeEventHandler, MouseEventHandler } from "react";
import { passPhrase } from "../../../../constance/constance";

const ChangePasswordElement = ({
  setCurrentPasswordHandler,
  setNewPasswordHandler,
  setConfirmPasswordHandler,
  sendPasswordHandler,
  ApiErrMsg,
  ErrMsgs,
}: {
  setCurrentPasswordHandler: ChangeEventHandler<HTMLInputElement>;
  setNewPasswordHandler: ChangeEventHandler<HTMLInputElement>;
  setConfirmPasswordHandler: ChangeEventHandler<HTMLInputElement>;
  sendPasswordHandler: MouseEventHandler<HTMLButtonElement>;
  ApiErrMsg: string;
  ErrMsgs: {
    currentPassword: string;
    confirmPassword: string;
    confirmPasswordUnder: boolean;
  };
}) => (
  <FormWrap>
    <div className="align_left">
      <h2 className="mt0 mb0 ml4">パスワード変更</h2>
      <hr className="mt0 mb0" />
      <ErrorMessage ApiErrMsg={ApiErrMsg} />
      <p className="align_left bold ml4 mt40 mb0 font-s">現在のパスワード</p>
      <TextField
        iserror={ErrMsgs.currentPassword}
        id="textfield1"
        fullwidth
        type="password"
        onChange={setCurrentPasswordHandler}
      />
    </div>
    <p className="align_left bold ml4 mt32 mb0 font-s">新しいパスワード</p>
    <TextField
      iserror={ErrMsgs.confirmPassword}
      id="textfield2"
      label={passPhrase}
      fullwidth
      type="password"
      onChange={setNewPasswordHandler}
    />
    <TextField
      iserror={ErrMsgs.confirmPasswordUnder}
      id="textfield3"
      label="もう一度入力してください"
      fullwidth
      type="password"
      onChange={setConfirmPasswordHandler}
    />
    <Box mt={32}>
      <Button variant="primary" onClick={sendPasswordHandler} fullwidth_mobile={true}>
        パスワードを変更する
      </Button>
    </Box>
  </FormWrap>
);

export default ChangePasswordElement;
